import { inject, Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'priceFormat',
})
export class PriceFormatPipe implements PipeTransform {
  private currencyPipe = inject(CurrencyPipe);

  transform(value: number | string, currencyCode = 'USD', locale = 'en-US'): string | null {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return null;

    const hasDecimals = num % 1 !== 0;
    const digits = hasDecimals ? '1.2-2' : '1.0-0';
    // const digits = '1.0-0';
    return this.currencyPipe.transform(num, currencyCode, 'symbol', digits, locale);
  }
}
